module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v(_vm._s(_vm.displayable_number))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('MenuAccess', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.is_external),
      expression: "!is_external"
    }],
    ref: "menu_access"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.displayable_tabs),
      expression: "displayable_tabs"
    }],
    attrs: {
      "id": "tabs"
    }
  }, [_c('ul', {
    staticClass: "nav nav-pills mb-3",
    attrs: {
      "id": "tab-section",
      "data-tabs": "tabs"
    }
  }, [_c('li', {
    staticClass: "nav-item active"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "id": "0",
      "data-toggle": "pill"
    },
    on: {
      "click": function($event) {
        return _vm.selectReturnsTab(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.tabs[0]))])]), _vm._v(" "), (_vm.returns.has_payment) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "id": "1",
      "data-toggle": "pill"
    },
    on: {
      "click": function($event) {
        return _vm.selectReturnsTab(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.tabs[1]))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_vm._v("\n          " + _vm._s(this.$slots.default) + "\n        ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac35af76"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/returns_renderer.vue
// module id = 1039
// module chunks = 0